/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Consents_GrantInputs */

const cs_clients_consents_grant = /** @type {(inputs: Clients_Consents_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udělit souhlas`)
};

const en_clients_consents_grant = /** @type {(inputs: Clients_Consents_GrantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grant consent`)
};

/**
* | output |
* | --- |
* | "Grant consent" |
*
* @param {Clients_Consents_GrantInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_consents_grant = /** @type {((inputs?: Clients_Consents_GrantInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Consents_GrantInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_consents_grant(inputs)
	return cs_clients_consents_grant(inputs)
});